import type { MasterdataSearchSettings } from './types/masterdata-search-settings';

export const SOFTLINE_MODULE_MASTERDATA = 'masterdata';
export const SOFTLINE_PERMISSION_MASTERDATA = 'SOFTAPPS.MASTERDATA_TEST';
export const SOFTLINE_SETTINGS_MASTERDATA_SEARCH = 'masterdata-search';

export const MASTERDATA_SEARCH_SETTINGS_DEFAULT: MasterdataSearchSettings = {
  openDropdownOnFocus: true,
};
